module.exports = __webpack_public_path__ + "static/img/M-3.973699c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mga/M-3.png
// module id = W/sO
// module chunks = 0